import { CapoPlugin } from "/home/forge/stage.efxpp.ch/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];